import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import { NauticalMiles } from "../../../../../../domain/units/NauticalMiles";
import { unwrapValue } from "../../../../../../shared/utils/unwrapValue";
import { eqeqeq } from "../../../../../../shared/utils/equality";
import GenericNumberFormItemProvider from "../../_generic/number/GenericNumberFormItemProvider";

const fieldName = "Engine Distance";

const EngineDistanceFormItemProvider: FormItemProvider<NauticalMiles> = (props: FormItemProviderProps<NauticalMiles>) => (
  <GenericNumberFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="EngineDistance"
    addonAfter="NM"
    allowNegative={false}
    integersOnly={false}
    inputToResult={notEmptyInputToResultWrapper(fieldName, (input: number) => ok(new NauticalMiles(input)))}
    outputToInput={unwrapValue}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(EngineDistanceFormItemProvider);